import lifecycle from './lifecycle'
let btn = document.querySelector('.c-nav-toggle')
let menu = document.querySelector('.c-nav-moile-menu')
let header = document.querySelector('.c-header-container')

btn.addEventListener('click', () => {
  lifecycle.interactivityRequested();
  menu.setAttribute('aria-expanded', menu.getAttribute('aria-expanded') !== "true")
})

header.addEventListener('mouseenter', () => {
  lifecycle.interactivityRequested();
})